import { BaseModel } from "@/models/base.model.ts"
import type { IRoleServiceProviderMachine } from "@/interfaces/api/role-service-provider-machine.interface.ts"
import { ModelFactory } from "@/factories/model-factory.ts"
import { Machine } from "@/models/machine.model.ts"
import { PurchaseItem } from "@/models/purchase-item.model.ts"

import { SaleItem } from "@/models/sale-item.model"

export class RoleServiceProviderMachine extends BaseModel implements IRoleServiceProviderMachine {
  public static className = "RoleServiceProviderMachine" // Used for socket communication.
  public static verboseName = "rol dienstverlener machine"

  roleServiceProvider: string
  machine: Machine
  purchaseItem: PurchaseItem | null
  saleItem: SaleItem | null
  sortIndex: number

  constructor(roleServiceProviderMachine: IRoleServiceProviderMachine, managed = false) {
    super(roleServiceProviderMachine)

    this.roleServiceProvider = roleServiceProviderMachine.roleServiceProvider
    this.machine = ModelFactory.childModel(Machine, roleServiceProviderMachine.machine, managed)
    this.purchaseItem =
      ModelFactory.childModel(PurchaseItem, roleServiceProviderMachine.purchaseItem, managed) ??
      null
    this.saleItem =
      ModelFactory.childModel(SaleItem, roleServiceProviderMachine.saleItem, managed) ?? null
    this.sortIndex = roleServiceProviderMachine.sortIndex
  }
}
